import { requestPermission } from "./checkPermission.js";
import * as Util from "./util.js";

async function retreivePublicKey(): Promise<string> {
    const res = await fetch("./public_key.txt");
    return res.text();
}

const pubkeyPromise = retreivePublicKey();

(async () => {
    if (!("serviceWorker" in navigator)) {
        throw new Error("サービスワーカーに対応していません。");
    }

    await navigator.serviceWorker.register("./worker.global.js");
    console.log("サービスワーカー登録成功");

    const permission = await requestPermission();

    if (permission !== "granted") {
        throw new Error(`NotificationPermission: ${permission}`);
    }

    console.log("NotificationPermission: granted");
})();

// eslint-disable-next-line @typescript-eslint/no-misused-promises
window.addEventListener("DOMContentLoaded", async () => {
    const applicationServerKey = await pubkeyPromise;

    const reg = await navigator.serviceWorker.ready;

    navigator.serviceWorker.addEventListener("message", (event) => {
        console.log("message from service worker:", event.data);
    });

    const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
    });

    console.log("pushサブスクライブ完了");

    const x = Util.getElementById("subscription");

    x.textContent = Util.JSONStringify(subscription.toJSON(), undefined, "  ");
});
